export default __webpack_public_path__ + "static/assets/7c1343b98e6b76c182a8edad83441f2c.gif";